exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hyperlink-force-pointer-events[data-v-5d1478bf] {\n  pointer-events: all;\n}\n", "", {"version":3,"sources":["C:/IBE_Agent1/_work/11/s/src/Nps.Frontier.Web/VueApps/Shared/Components/sections/frontierLegal.vue"],"names":[],"mappings":";AAAA;EACE,oBAAoB;CACrB","file":"frontierLegal.vue","sourcesContent":[".hyperlink-force-pointer-events {\n  pointer-events: all;\n}\n"],"sourceRoot":""}]);

// exports
